 <!-- ======= Footer ======= -->
 <footer id="footer">
    <div class="container">
      
      <div class="copyright">
        &copy; Copyright <strong><span>สำนักงานศาลปกครอง.</span></strong> All Rights Reserved.
      </div>
      <div class="credits">
        <!-- All the links in the footer should remain intact. -->
        <!-- You can delete the links only if you purchased the pro version. -->
        <!-- Licensing information: https://bootstrapmade.com/license/ -->
        <!-- Purchase the pro version with working PHP/AJAX contact form: https://bootstrapmade.com/knight-simple-one-page-bootstrap-template/ -->
        <!-- Best viewed with Google Chrome 71 or IE 11.0  -->
        <!-- <a href="https://bootstrapmade.com/">BootstrapMade</a> -->
      </div>
    </div>
  </footer><!-- End Footer -->